<template lang="pug">
.block
  button.flex.items-center.btn.m-auto.pt-2( 
    :class="[buttonStatus,{'rounded-4': borderRadius =='4','rounded-20':!borderRadius},{'gradientTop': gradientTop}]" 
    :style="{'background': selected ?  '#005566' : '' , 'height': height +'px'}"
    @click.stop="clickHandler" :disabled="disable")
    //- iCon.h-25.w-25.inline-block(:iconClass="icon" type="svg" v-if="icon")
    .text-center.self-center.leading-initial(v-if="text" :style="{ 'font-size': textSize +'px'}" )  {{text}}
</template>

<script>
export default {
  name: "Button",
  props: {
    gradientTop: {
      type: Boolean,
      default: false
    },
    textSize: {
      type: String,
      required: false,
      default: "15"
    },
    text: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    type: {
      //下列css的name
      type: String,
      default: "normal"
    },
    borderRadius: {
      type: String,
      required: false
    },
    height: {
      type: [String, Number],
      required: false
    },
    selected: {
      //tab 形式的樣式
      type: Boolean,
      required: false
    }
  },
  data() {
    return {};
  },
  methods: {
    clickHandler() {
      this.$emit("buttonClick");
    }
  },
  computed: {
    buttonStatus: function() {
      // console.log('??',this.disable ? this.type +' '+ 'disable' : this.type)
      return this.disable ? this.type + " " + "disable" : this.type;
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  @apply w-full  h-36  block;
  &.btn {
    // @apply  text-white bg-gradient-to-r border border-main-sub2 from-main-sub1 via-main-sub2 to-main-sub3;
    @apply text-white  border border-main-sub2 bg-main-0;
    transition: all 0.1s linear;
    &:hover {
      // box-shadow: 0px 4px 8px 0 rgba(0, 0, 0, 0.3);
      @apply border border-main-deep  bg-main-deep;
      // @apply   bg-gradient-to-r from-main-teal to-main-teal shadow-button;
    }
    &:active {
      @apply border border-main-deep  bg-main-deep;
      // @apply text-white border border-main-sub2  bg-gradient-to-r from-main-0 to-main-0 shadow-none;
    }
    &.disable {
      @apply cursor-not-allowed bg-main-disable border-main-disable;
      &:hover {
        // @apply text-white  bg-gradient-to-r border border-main-sub2 from-main-sub1 via-main-sub2 to-main-sub3  shadow-none;
        @apply bg-main-disable border-main-disable;
      }
    }
  }
  &.gradientTop {
    @apply text-white bg-gradient-to-t from-main-0 to-main-linear;
    transition: all 0.3s linear;
    &:hover {
      // @apply   bg-gradient-to-t from-main-teal to-main-teal shadow-button;
      @apply text-main-0  bg-gradient-to-t from-main-alice to-main-alice;
    }
    &:active {
      @apply text-white  bg-gradient-to-t from-main-deep to-main-deep shadow-none;
      box-shadow: 0px 4px 8px 0 rgba(0, 0, 0, 0.3);
    }
    &.disable {
      @apply opacity-40 cursor-not-allowed;
      &:hover {
        @apply bg-gradient-to-t from-main-0 to-main-linear  shadow-none;
      }
    }
  }

  &.smallSub {
    @apply border text-main-0 border-main-0 bg-none bg-white;
    transition: all 0.1s linear;
    &:hover {
      @apply border border-grey-99 text-main-0 bg-gradient-to-r from-white to-white;
    }
    &:active {
      @apply text-white border border-main-sub2  bg-gradient-to-r from-main-0 to-main-0 shadow-none;
    }
    &.disable {
      @apply border text-main-0 border-main-0 bg-none bg-white;
      &:hover {
        @apply border text-main-0 border-main-0 bg-none bg-white;
      }
    }
  }

  &.smallMain {
    @apply border border-main-sub4 text-white bg-none bg-main-sub4;
    transition: all 0.1s linear;
    &:hover {
      // @apply bg-none bg-white border-main-0 text-main-0 shadow-button;
      @apply border border-grey-99 text-main-0 bg-gradient-to-r from-white to-white;
    }
    &:active {
      // @apply   bg-main-deep shadow-none text-white;
      @apply text-white border border-main-sub2  bg-gradient-to-r from-main-0 to-main-0 shadow-none;
    }
    &.disable {
      @apply border border-main-sub4 text-white bg-none bg-main-sub4;
      &:hover {
        @apply border border-main-sub4 text-white bg-none bg-main-sub4;
        // @apply  bg-none bg-white  border-grey-b4 shadow-none;
      }
    }
  }
  &.borderSolid {
    @apply border text-main-0 border-main-0 bg-none;
    background-color: transparent;
    transition: all 0.1s linear;
    &:hover {
      // @apply  border border-grey-99 text-main-0 bg-gradient-to-r from-white to-white;
      @apply border text-white border-main-deep  bg-main-deep;
    }
    &:active {
      // @apply text-white border border-main-sub2  bg-gradient-to-r from-main-0 to-main-0 shadow-none;
      @apply border text-white border-main-deep  bg-main-deep;
    }
    &.disable {
      @apply border text-main-disable border-main-disable bg-white;
      &:hover {
        @apply border text-main-disable border-main-disable bg-white;
      }
    }
  }
  &.ada {
    @apply border text-main-adaLight border-main-adaLight bg-none;
    background-color: transparent;
    transition: all 0.1s linear;
    &:hover {
      // @apply  border border-grey-99 text-main-adaLight bg-gradient-to-r from-white to-white;
      @apply border text-white border-main-deep  bg-main-deep;
    }
    &:active {
      // @apply text-white border border-main-sub2  bg-gradient-to-r from-main-adaLight to-main-adaLight shadow-none;
      @apply border text-white border-main-deep  bg-main-deep;
    }
    &.disable {
      @apply opacity-40 cursor-not-allowed  border text-main-adaLight border-main-adaLight bg-none;
      &:hover {
        @apply border text-main-adaLight border-main-adaLight bg-none;
      }
    }
  }

  &.error {
    @apply bg-error;
  }
  &.warning {
    @apply bg-green-500;
  }
}
</style>
